import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { BillingTermWithUsageFields } from '../../../../shared/model-typings/billingterm';

function fetchBillingTerms() {
  return get<BillingTermWithUsageFields[]>('/api/organization/billing-terms');
}

export const getBillingTermsQueryKey = (): QueryKey => ['organization', 'billingTerms'];

/**
 * Hook to fetch billing terms for the current organization.
 * @returns Query result containing the list of billing terms with usage data
 */
export const useBillingTerms = () => {
  return useQuery<BillingTermWithUsageFields[]>({
    queryKey: getBillingTermsQueryKey(),
    queryFn: fetchBillingTerms,
    staleTime: 30000, // Cache for 30 seconds
  });
};
